import { IModel, IAttribute, Collection } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Activity } from './activity';
import { Pipeline } from './pipeline';

import { format } from 'app/shared/utils/string.util';
import { ModelConstants } from 'shell-models-lib';

@Metamodel.model({
    name: ModelConstants.forEachActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.ForEachActivityLabel),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.ForEachActivityLabel)
    ],
    referable: true
})
export class ForEachActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly ITEMS: IAttribute;

    public isSequential?: boolean;

    @Metamodel.attribute({
        display: stringResources.ForEachActivityConfigurationBatchCount,
        constraint: {
            required: false,
            whole: true,
            minimum: 1,
            maximum: 50
        }
    })
    public batchCount?: number;

    // This property should always be an Expression type.
    @Metamodel.attribute({
        display: stringResources.ItemsLabel,
        templatable: true,
        collection: Collection.Array,
        association: 'ITEMS',
        constraint: {
            required: true
        }
    })
    public items: object[];

    @Metamodel.attribute({
        display: stringResources.Pipeline,
        constraint: {
            required: true
        },
        type: Pipeline.MODEL
    })
    public pipeline?: Pipeline;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ControlActivity';
    }

    public onActivityCloned(clonedActivity: ForEachActivity, context: { inlineDataset?: boolean }): void {
        if (this.pipeline.activities != null) {
            this.pipeline.activities.forEach((activity) => {
                const targetActivity = clonedActivity.pipeline?.activities?.find((targetActivity) => targetActivity.name === activity.name);
                if (targetActivity != null && activity instanceof Activity) {
                    activity.onActivityCloned(targetActivity, context);
                }
            })
        }
    }
}
